import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { TacticMode } from 'basics/enums/maya.enums';
import { TacticStateType } from 'basics/types/maya.types';
import TacticKanban from 'components/CepForm/Steps/TacticsStep/TacticKanban/TacticKanban';
import useTacticsStep from 'components/CepForm/Steps/TacticsStep/TacticsStep.hook';
import { ClosingCrossStyle, TacticDialogStyle } from 'components/CepForm/Steps/TacticsStep/TacticsStep.styles';
import { TacticStepPropsType } from 'components/CepForm/Steps/TacticsStep/TacticStep.types';
import TacticForm from 'components/TacticForm/TacticForm';
import tacticState from 'states/tactic.states';
import Dialog from 'yoda-ui/components/Dialogs/Dialog';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';

const TacticsStep: FC<TacticStepPropsType> = ({ isTemplate }) => {
  const tacticStateValue = useSnapshot(tacticState) as TacticStateType;
  const { handleTacticDialogClose } = useTacticsStep();

  return (
    <>
      {
        tacticStateValue.mode === TacticMode.form
          ? <Dialog
            open={ tacticStateValue.mode === TacticMode.form }
            maxWidth="md"
            minWidth="50%"
            minHeight="620px"
            sx={ TacticDialogStyle }
          >
            <Icon
              name={ Icons.close }
              fontSize="medium"
              style={ ClosingCrossStyle }
              onClick={ handleTacticDialogClose }
            />
            <TacticForm isTemplate={ isTemplate }/>
          </Dialog>
          : <TacticKanban />
      }
    </>
  );
};

export default TacticsStep;
